export default {
  baseURL: 'https://api.financeiro.cenprotnacional.org.br/',
  mode: 'prod',
  dev: {
    nome_usuario: '',
    token: ''
  }
}
